import React, { Component } from "react";

import {
  FilteredViewWrapper,
  GridContainer,
  PaginationContainer
} from "./FilteredView.style";
import { FilteredViewCardFooter } from "./FileredViewCardFooter/FilteredViewCardFooter";
import { Pagination2 } from "../../UserPage/Common/Pagination2/Pagination2";
import  Card  from "./Card/Card";
import EmptyVideo from '../../UserPage/MyVideo/emptyVideo/emptyVideo';
import i18n from "../../i18n";

import TemplateHelper from '@/utils/TemplateHelper'

export class FilteredView extends Component {

  replaceTemplateName = name => {
    if (typeof name !== 'string') return null

    name = name.replace(' 16:9', '').replace(' 1:1', '').replace(' 4:5', '').replace(' 9:16', '')
    if (name.includes(' Title') || name.includes(' End')) name = `${name.replace(' Title', '').replace(' End', '')} Title & End`
    
    return name
  }

  render() {
    const {
      isOld,
      isVM,
      value: lang,
      filteredTemplates,
      filteredTemplatesTotalCount,
      onThumbnailClicked,
      filterRequested,
      currentPage,
      cardsPerPage,
      onPageNumberClicked,
      onPreviousPageClicked,
      onNextPageClicked,
      cardSize = undefined
    } = this.props;

    const templates = TemplateHelper.GetRepresentedTemplates(filteredTemplates, this.props.value)
    if (!filterRequested) return null
    if (!templates) return null
    return (
      <FilteredViewWrapper isOld={isOld}>
            {templates.length === 0 ?   
          <EmptyVideo
          isNew={isVM ? true : false}
          onViewAllFreeVideosButtonClicked={
            this.onViewAllFreeVideosButtonClicked
          }
          text1={i18n.t("DefaultView.no.search.result")}
          // text2={`다른 이름으로 검색해주세요`}
          btn={false}
          img="https://front.videomonster.com/images-u6yd72dy/web/Empty-icon.png"
        /> : null}
        <GridContainer isOld={isOld}>
      
          {templates
            .map((template, index) => {
              const groupData = filteredTemplates[index]
              return (
                <Card
                  cardSize={cardSize}
                  key={template._id}
                  previewUrl={TemplateHelper.ConvertURLToSmallURL(TemplateHelper.getPreviewVideo(template, lang))}
                  thumbnailUrl={TemplateHelper.getThumbnailImage(template, lang, true) || ""}
                  onThumbnailClicked={onThumbnailClicked(groupData, template.key)}
                  title={this.replaceTemplateName(TemplateHelper.getName(template, lang))}
                  date={template.date}
                  isEditable={template.isEditableApproved}
                  isPremium={template.isPremium}
                  isNewTemplate={template.isNewTemplate}
                />
              )
            })}
        </GridContainer>
        {filteredTemplatesTotalCount.length === 0 ? null : (
          <PaginationContainer>
            <Pagination2
              currentPage={currentPage}
              cardsPerPage={cardsPerPage}
              itemCount={filteredTemplatesTotalCount}
              onPageNumberClicked={onPageNumberClicked}
              onPreviousPageClicked={onPreviousPageClicked}
              onNextPageClicked={onNextPageClicked}
            />
          </PaginationContainer>
        )}
      </FilteredViewWrapper>
    );
  }
}
